import gql from 'graphql-tag';

export default gql`
	mutation EditSurvey(
		$id: ID
		$published: Boolean
		$titulo: String
		$tiempo: String
		$fecha: String
		$descripcion: String
	) {
		editSurvey(
			id: $id
			published: $published
			titulo: $titulo
			fecha: $fecha
			tiempo: $tiempo
			descripcion: $descripcion
		) {
			id
		}
	}
`;



// WEBPACK FOOTER //
// ./src/mutations/editSurvey.js